import { defineMessages } from 'react-intl';
export default defineMessages({
    articleCount: {
        id: 'helpCenter.articleCount',
        defaultMessage: '{count, plural, one {# article} other {# articles}}'
    },
    articleNotFound: {
        id: 'helpCenter.articleNotFound',
        defaultMessage: 'Article Not Found'
    },
    articleNotFoundDescription: {
        id: 'helpCenter.articleNotFoundDescription',
        defaultMessage: "The article you're looking for doesn't exist."
    },
    backToHelpCenter: {
        id: 'helpCenter.backToHelpCenter',
        defaultMessage: 'Back to Help Center'
    },
    browseByCategory: {
        id: 'helpCenter.browseByCategory',
        defaultMessage: 'Browse by Category'
    },
    categoryNotFound: {
        id: 'helpCenter.categoryNotFound',
        defaultMessage: 'Category not found'
    },
    categoryNotFoundDescription: {
        id: 'helpCenter.categoryNotFoundDescription',
        defaultMessage: "This category doesn't exist or has no articles."
    },
    contactSupport: {
        id: 'helpCenter.contactSupport',
        defaultMessage: 'Contact support'
    },
    feedbackHelpsImprove: {
        id: 'helpCenter.feedbackHelpsImprove',
        defaultMessage: 'Your input helps us improve our help articles.'
    },
    feedbackReasonNotAnswer: {
        id: 'helpCenter.feedbackReasonNotAnswer',
        defaultMessage: "It doesn't answer my question"
    },
    feedbackReasonOutdated: {
        id: 'helpCenter.feedbackReasonOutdated',
        defaultMessage: 'The information is outdated'
    },
    feedbackReasonUnclear: {
        id: 'helpCenter.feedbackReasonUnclear',
        defaultMessage: 'The instructions are unclear'
    },
    feedbackWhatWentWrong: {
        id: 'helpCenter.feedbackWhatWentWrong',
        defaultMessage: 'What was the problem?'
    },
    helpCategoryAccount: {
        id: 'helpCenter.helpCategoryAccount',
        defaultMessage: 'Account'
    },
    helpCategoryBilling: {
        id: 'helpCenter.helpCategoryBilling',
        defaultMessage: 'Billing'
    },
    helpCategoryForecast: {
        id: 'helpCenter.helpCategoryForecast',
        defaultMessage: 'Forecasts'
    },
    helpCategoryGettingStarted: {
        id: 'helpCenter.helpCategoryGettingStarted',
        defaultMessage: 'Getting Started'
    },
    helpCategoryProviders: {
        id: 'helpCenter.helpCategoryProviders',
        defaultMessage: 'Providers'
    },
    helpCategoryStations: {
        id: 'helpCenter.helpCategoryStations',
        defaultMessage: 'Stations'
    },
    helpCategoryTroubleshooting: {
        id: 'helpCenter.helpCategoryTroubleshooting',
        defaultMessage: 'Troubleshooting'
    },
    helpCenter: {
        id: 'helpCenter.helpCenter',
        defaultMessage: 'Help Center'
    },
    landingDescription: {
        id: 'helpCenter.landingDescription',
        defaultMessage: 'Find answers to common questions and learn how to get the most out of SmartMixin.'
    },
    linkToSection: {
        id: 'helpCenter.linkToSection',
        defaultMessage: 'Link to this section'
    },
    menuItemDescription: {
        id: 'helpCenter.menuItemDescription',
        defaultMessage: 'FAQs and guides'
    },
    minRead: {
        id: 'helpCenter.minRead',
        defaultMessage: '{minutes} min read'
    },
    onThisPage: {
        id: 'helpCenter.onThisPage',
        defaultMessage: 'On this page'
    },
    platformMobileApp: {
        id: 'helpCenter.platformMobileApp',
        defaultMessage: 'Mobile app'
    },
    platformMobileOnly: {
        id: 'helpCenter.platformMobileOnly',
        defaultMessage: 'Mobile app only'
    },
    platformWebApp: {
        id: 'helpCenter.platformWebApp',
        defaultMessage: 'Web app'
    },
    platformWebOnly: {
        id: 'helpCenter.platformWebOnly',
        defaultMessage: 'Web app only'
    },
    popularArticles: {
        id: 'helpCenter.popularArticles',
        defaultMessage: 'Popular articles'
    },
    relatedArticles: {
        id: 'helpCenter.relatedArticles',
        defaultMessage: 'Related Articles'
    },
    searchArticles: {
        id: 'helpCenter.searchArticles',
        defaultMessage: 'Search articles...'
    },
    stillNeedHelp: {
        id: 'helpCenter.stillNeedHelp',
        defaultMessage: 'Still need help?'
    },
    stillNeedHelpDescription: {
        id: 'helpCenter.stillNeedHelpDescription',
        defaultMessage: "If this article didn't answer your question, I'm happy to help you directly."
    },
    supportEmailSubject: {
        id: 'helpCenter.supportEmailSubject',
        defaultMessage: 'SmartMixin Help'
    },
    supportEmailSubjectTopic: {
        id: 'helpCenter.supportEmailSubjectTopic',
        defaultMessage: 'SmartMixin Help — {topic}'
    },
    thankYouForFeedback: {
        id: 'helpCenter.thankYouForFeedback',
        defaultMessage: 'Thank you for your feedback!'
    },
    wasArticleHelpful: {
        id: 'helpCenter.wasArticleHelpful',
        defaultMessage: 'Was this article helpful?'
    }
});
